<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <div class="admin-add-menu fullheight">
        <v-toolbar dark :color="'#9e9e9e'">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            ><h1
              class="header-tittle"
              :style="{ color: colorsGeneralSecondary }"
            >
              {{ title }}
            </h1>
          </v-toolbar-title>
        </v-toolbar>

        <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>

        <v-container fluid>
          <v-form
            ref="form"
            v-model="isValid"
            lazy-validation
            @submit.prevent="submitForm"
          >
            <v-row>
              <v-col cols="12" sm="3" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Nombre :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="8" class="py-0 py-sm-1">
                <v-text-field
                  v-model="input.name"
                  :rules="validation.name"
                  required
                  placeholder="E.g. Agua"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="isHomeVersionPremium">
              <v-col cols="12" sm="3" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Imagen :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="4" class="py-0 py-sm-1">
                <FileInput
                  :value="menuImage"
                  :type="'menu'"
                  @setImageUrl="setImageUrl($event)"
                  accept="image/png, image/jpeg, image/jpg"
                />
              </v-col>
              <v-col cols="12" sm="2" class="py-0 py-sm-1 d-flex">
                <div class="menu-img">
                  <img :src="input.menu_image" :alt="input.menu_image" />
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Color Principal :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="8" class="py-0 py-sm-1 d-flex">
                <v-text-field
                  v-model="input.primaryColor"
                  placeholder="E.g. #F8D1AC"
                  @input="changeColor('menuPrimary')"
                ></v-text-field>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn :color="menuPrimary" dark v-on="on"> </v-btn>
                  </template>
                  <v-color-picker
                    value="#7417BE"
                    v-model="menuPrimary"
                    hide-canvas
                    hide-inputs
                    show-swatches
                    class="mx-auto"
                    @input="onChangeColor('menuPrimary')"
                  ></v-color-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Color Segundario :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="8" class="py-0 py-sm-1 d-flex">
                <v-text-field
                  v-model="input.secondaryColor"
                  placeholder="E.g. #C3C0B5"
                  @input="changeColor('menuSecondary')"
                ></v-text-field>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn :color="menuSecondary" dark v-on="on"> </v-btn>
                  </template>
                  <v-color-picker
                    value="#7417BE"
                    v-model="menuSecondary"
                    hide-canvas
                    hide-inputs
                    show-swatches
                    class="mx-auto"
                    @input="onChangeColor('menuSecondary')"
                  ></v-color-picker>
                </v-menu>
              </v-col>
            </v-row>

            <div>
              <ExpansionPanels
                type="Drink"
                ref="drinkExpansionPanels"
                :accordionsPanel="drinksPanel"
                :headers="headers"
                :getCollections="getDrinks"
                :searchInput.sync="searchDrinks"
                :categories="categoriesDrink"
                :categorySelected.sync="drinksCategorySelected"
                :selection="selection"
                :selectionSelected.sync="drinksSelectionSelected"
                title="Selecciona la BEBIDA"
                @onChangeSelection="onDrinkSelect"
              />
            </div>
            <br />
            <div>
              <ExpansionPanels
                type="Food"
                ref="foodExpansionPanels"
                :accordionsPanel="foodPanel"
                :headers="headers"
                :getCollections="getFood"
                :searchInput.sync="searchFood"
                :categories="categoriesFood"
                :categorySelected.sync="foodCategorySelected"
                :selection="selection"
                :selectionSelected.sync="foodSelectionSelected"
                title="Selecciona la COMIDA"
                @onChangeSelection="onFoodSelect"
              />
            </div>
            <br />
            <div>
              <ExpansionPanels
                type="Dessert"
                ref="dessertExpansionPanels"
                :accordionsPanel="dessertPanel"
                :headers="headers"
                :getCollections="getDessert"
                :searchInput.sync="searchDessert"
                :categories="categoriesDessert"
                :categorySelected.sync="dessertCategorySelected"
                :selection="selection"
                :selectionSelected.sync="dessertSelectionSelected"
                title="Selecciona el POSTRE"
                @onChangeSelection="onDessertSelect"
              />
            </div>

            <v-row>
              <v-col align="center">
                <div class="my-2 mr-5">
                  <v-btn
                    dense
                    outlined
                    :disabled="!isValid"
                    type="submit"
                    :style="adminNavigationBackTheme"
                  >
                    Guardar
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import Loader from "@/components/common/Loader";
import FileInput from "@/components/common/FileInput";
import ExpansionPanels from "@/components/admin/menus/ExpansionPanels";
import moment from "moment";
import { saveUiMenuOrder } from "@/collections/uiMenuOrder";
import { MenuDialogHeader } from "@/utils/tableHeaderconstants";
import { saveScheduleByMenu } from "@/collections/scheduleByMenu";
import { categoriesCollection } from "@/collections/categories";
import { dessertCollection } from "@/collections/dessert";
import { foodCollection } from "@/collections/food";
import { drinksCollection } from "@/collections/drinks";
import { getMenuById, menusCollection, saveMenu } from "@/collections/menus";

export default {
  name: "menus-dialog",
  components: {
    Loader,
    FileInput,
    ExpansionPanels
  },
  data() {
    return {
      id: "addMenu",
      dialog: false,
      title: "",
      drinks: [],
      food: [],
      dessert: [],
      dialogLoader: false,
      isValid: false,
      input: {
        id: "",
        name: "",
        primaryColor: "",
        secondaryColor: "",
        food_ids: [],
        drink_ids: [],
        dessert_ids: [],
        active: true,
        menu_image: "",
        type: "menus",
        sort: 1000
      },
      validation: {
        name: [v => (!!v && !!v.trim()) || "Nombre es requerido"]
      },
      menusCollection: [],
      drinksPanel: {
        accordion: false,
        popout: false,
        inset: false,
        multiple: false,
        disabled: false,
        readonly: false,
        focusable: false,
        flat: false,
        hover: false,
        tile: false
      },
      foodPanel: {
        accordion: false,
        popout: false,
        inset: false,
        multiple: false,
        disabled: false,
        readonly: false,
        focusable: false,
        flat: false,
        hover: false,
        tile: false
      },
      dessertPanel: {
        accordion: false,
        popout: false,
        inset: false,
        multiple: false,
        disabled: false,
        readonly: false,
        focusable: false,
        flat: false,
        hover: false,
        tile: false
      },
      menuPrimary: "#000000",
      menuSecondary: "#9E9E9E",
      categoriesCollection: [],
      headers: [...MenuDialogHeader],
      searchDrinks: "",
      searchFood: "",
      searchDessert: "",
      drinksCategorySelected: "",
      foodCategorySelected: "",
      dessertCategorySelected: "",
      drinksSelectionSelected: "",
      foodSelectionSelected: "",
      dessertSelectionSelected: "",
      selection: [
        {
          text: "Todos",
          value: ""
        },
        {
          text: "Si",
          value: true
        },
        {
          text: "No",
          value: false
        }
      ]
    };
  },
  firestore() {
    return {
      drinks: drinksCollection.orderBy("name"),
      food: foodCollection.orderBy("name"),
      dessert: dessertCollection.orderBy("name"),
      menusCollection: menusCollection,
      categoriesCollection: categoriesCollection
    };
  },
  computed: {
    categoriesDrink() {
      // get the categories based on product type Drink
      let drinkCategory = this.categoriesCollection.filter(
        category =>
          process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID ===
          category.product_type_id
      );
      return [{ id: "", name: "Todas" }, ...drinkCategory];
    },
    categoriesFood() {
      // get the categories based on product type Food
      let foodCategory = this.categoriesCollection.filter(
        category =>
          process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID === category.product_type_id
      );
      return [{ id: "", name: "Todas" }, ...foodCategory];
    },
    categoriesDessert() {
      // get the categories based on product type Dessert
      let dessertCategory = this.categoriesCollection.filter(
        category =>
          process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID ===
          category.product_type_id
      );
      return [{ id: "", name: "Todas" }, ...dessertCategory];
    },
    getDrinks() {
      let filterDrinks = this.drinks.filter(item => item.stock > 0);
      filterDrinks = filterDrinks.map(x => {
        let isActive = this.input.drink_ids.find(y => x.id === y);
        x.active = !!isActive;
        return x;
      });

      filterDrinks =
        this.searchDrinks !== ""
          ? filterDrinks.filter(x => {
              if (
                x.name.toLowerCase().includes(this.searchDrinks.toLowerCase())
              ) {
                return x;
              }
            })
          : filterDrinks;

      filterDrinks =
        this.drinksCategorySelected !== ""
          ? filterDrinks.filter(
              drink => this.drinksCategorySelected === drink.category_id
            )
          : filterDrinks;

      filterDrinks =
        this.drinksSelectionSelected !== ""
          ? filterDrinks.filter(
              drink => this.drinksSelectionSelected === drink.active
            )
          : filterDrinks;

      return filterDrinks;
    },
    getFood() {
      let filterFood = this.food.filter(item => item.stock > 0);
      filterFood = filterFood.map(x => {
        let isActive = this.input.food_ids.find(y => x.id === y);
        x.active = !!isActive;
        return x;
      });

      filterFood =
        this.searchFood !== ""
          ? filterFood.filter(x => {
              if (
                x.name.toLowerCase().includes(this.searchFood.toLowerCase())
              ) {
                return x;
              }
            })
          : filterFood;

      filterFood =
        this.foodCategorySelected !== ""
          ? filterFood.filter(
              food => this.foodCategorySelected === food.category_id
            )
          : filterFood;

      filterFood =
        this.foodSelectionSelected !== ""
          ? filterFood.filter(
              food => this.foodSelectionSelected === food.active
            )
          : filterFood;

      return filterFood;
    },
    getDessert() {
      let filterDessert = this.dessert.filter(item => item.stock > 0);
      filterDessert = filterDessert.map(x => {
        let isActive = this.input.dessert_ids.find(y => x.id === y);
        x.active = !!isActive;
        return x;
      });

      filterDessert =
        this.searchDessert !== ""
          ? filterDessert.filter(x => {
              if (
                x.name.toLowerCase().includes(this.searchDessert.toLowerCase())
              ) {
                return x;
              }
            })
          : filterDessert;

      filterDessert =
        this.dessertCategorySelected !== ""
          ? filterDessert.filter(
              dessert => this.dessertCategorySelected === dessert.category_id
            )
          : filterDessert;

      filterDessert =
        this.dessertSelectionSelected !== ""
          ? filterDessert.filter(
              dessert => this.dessertSelectionSelected === dessert.active
            )
          : filterDessert;

      return filterDessert;
    },
    menuImage() {
      if (!this.input.menu_image) {
        return null;
      }

      return new File(
        [this.input.menu_image],
        this.input.menu_image
          .split("/")
          .pop()
          .split("?")[0]
      );
    }
  },
  methods: {
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    },
    async submitForm() {
      try {
        if (this.$refs.form.validate()) {
          if (this.id !== "addMenu") {
            // edit Menu

            // check update unique name
            let found = this.menusCollection.some(x => {
              if (
                x.name.toLowerCase().trim() ===
                  this.input.name.toLowerCase().trim() &&
                x.id.toLowerCase() !== this.id.toLowerCase()
              ) {
                return x;
              }
            });

            if (found) {
              this.showErrorMessage("El nombre debe ser único");
              return;
            }

            await this.saveMenu(this.id);
          } else {
            // Add Menu

            let found = this.menusCollection.some(
              x =>
                x.name.toLowerCase().trim() ===
                this.input.name.toLowerCase().trim()
            );
            if (found) {
              this.showErrorMessage("El nombre debe ser único");
              return;
            }

            let id = this.uuidv4();
            await this.saveMenu(id);

            let scheduleDoc = {
              schedule: {}
            };

            for (let i = 0; i <= 6; i++) {
              scheduleDoc.schedule[i] = {
                first: {
                  init: 0,
                  fin: 0
                },
                second: {
                  init: 0,
                  fin: 0
                }
              };
            }

            scheduleDoc.menuId = id;
            saveScheduleByMenu(id, scheduleDoc).catch(error => {
              this.setlogError(
                "save_schedule_by_menus",
                "Obtained error message in submitForm()",
                error.stack,
                this.$options.name
              );
            });
          }
          this.showSuccessMessage("Carta guardada");

          setTimeout(() => {
            this.close();
          }, 500);
        }
      } catch (error) {
        // eslint-disable-next-line
        this.setlogError(
          "save/update_menus",
          "Obtained error message in submitForm()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    },
    async saveMenu(id) {
      try {
        await saveMenu(id, this.buildMenu());
        await saveUiMenuOrder(id, {
          ...this.buildMenu(),
          id: id,
          type: "menus",
          sort: 1000
        });
      } catch (error) {
        this.setlogError(
          "save/update_menus",
          "Obtained error message in saveMenu()",
          error.stack,
          this.$options.name
        );
      }
    },
    buildMenu() {
      let now = moment().format();
      return { ...this.input, updated_on: now };
    },
    onDrinkSelect(product) {
      let foundIndex = this.input.drink_ids.findIndex(x => x === product.id);
      if (foundIndex === -1) {
        this.input.drink_ids.push(product.id);
      } else {
        this.input.drink_ids.splice(foundIndex, 1);
      }
    },
    onFoodSelect(product) {
      let foundIndex = this.input.food_ids.findIndex(x => x === product.id);
      if (foundIndex === -1) {
        this.input.food_ids.push(product.id);
      } else {
        this.input.food_ids.splice(foundIndex, 1);
      }
    },
    onDessertSelect(product) {
      let foundIndex = this.input.dessert_ids.findIndex(x => x === product.id);
      if (foundIndex === -1) {
        this.input.dessert_ids.push(product.id);
      } else {
        this.input.dessert_ids.splice(foundIndex, 1);
      }
    },
    open(itemId) {
      this.dialog = true;
      this.id = itemId;

      if (this.id === "addMenu") {
        setTimeout(() => {
          this.title = "Crear Carta";
        }, 100);
        this.dialogLoader = false;
        return;
      } else {
        setTimeout(() => {
          this.title = "Editar Carta";
        }, 100);
      }

      this.dialogLoader = true;
      let self = this;

      getMenuById(this.id)
        .then(menu => {
          if (menu) {
            self.input = menu;
            self.menuPrimary = self.input.primaryColor;
            self.menuSecondary = self.input.primaryColor;
          } else {
            this.close();
            this.input.menu_image = "";
          }
          self.dialogLoader = false;
        })
        .catch(error => {
          self.dialogLoader = false;
          this.setlogError(
            "get_menu_by_id",
            "Obtained error message in open()",
            error.stack,
            this.$options.name
          );
        });
    },
    close() {
      this.dialog = false;
      this.input = {
        name: "",
        primaryColor: "",
        secondaryColor: "",
        food_ids: [],
        drink_ids: [],
        dessert_ids: [],
        active: true,
        menu_image: ""
      };
      this.input.menu_image = null;
      this.menuPrimary = "#000000";
      this.menuSecondary = "#9E9E9E";

      this.$refs.form.resetValidation();
      this.resetDrinksPanel();
      this.resetFoodPanel();
      this.resetDessertPanel();
      this.resetFilters();
    },
    resetDrinksPanel() {
      this.drinksPanel = {
        accordion: false,
        popout: false,
        inset: false,
        multiple: false,
        disabled: false,
        readonly: false,
        focusable: false,
        flat: false,
        hover: false,
        tile: false
      };
    },
    resetFoodPanel() {
      this.foodPanel = {
        accordion: false,
        popout: false,
        inset: false,
        multiple: false,
        disabled: false,
        readonly: false,
        focusable: false,
        flat: false,
        hover: false,
        tile: false
      };
    },
    resetDessertPanel() {
      this.dessertPanel = {
        accordion: false,
        popout: false,
        inset: false,
        multiple: false,
        disabled: false,
        readonly: false,
        focusable: false,
        flat: false,
        hover: false,
        tile: false
      };
    },
    resetFilters() {
      this.searchFood = "";
      this.searchDrinks = "";
      this.searchDessert = "";
      this.drinksCategorySelected = "";
      this.foodCategorySelected = "";
      this.dessertCategorySelected = "";
      this.drinksSelectionSelected = "";
      this.foodSelectionSelected = "";
      this.dessertSelectionSelected = "";
    },
    setImageUrl(data) {
      this.input.menu_image = data.url;
      this.$forceUpdate();
    },
    onChangeColor(type) {
      if (type === "menuPrimary") {
        this.input.primaryColor = this.menuPrimary;
      } else {
        this.input.secondaryColor = this.menuSecondary;
      }
    },
    changeColor(type) {
      if (type === "menuPrimary") {
        this.menuPrimary = this.input.primaryColor;
      } else {
        this.menuSecondary = this.input.secondaryColor;
      }
    }
  }
};
</script>

<style>
.menu-img {
  width: 100px;
  height: 100px;
  align-items: center;
  display: flex;
  padding: 10px;
  border: 2px solid darkgray;
  justify-content: center;
}
.menu-img img {
  max-width: 100%;
  max-height: 80px;
}
</style>
